import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageWebService } from './storage-web.service';

export interface StorageData {
  availableUsage: number;
  databaseUsage: number;
  databaseUsageBySelectedCompany: number;
  fullStorage: number;
  fullUsage: number;
  storageUsage: number;
  storageUsageBySelectedCompany: number;
  otherUsage: number;
}

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private readonly _storageWebService: StorageWebService) {}

  public getStorageData(idUtente: string): Observable<any> {
    return this._storageWebService.getStorageData(idUtente);
  }
  public getUpdatedStorageData(idUtente: string): Observable<any> {
    return this._storageWebService.getUpdatedStorageData(idUtente);
  }
}
